import { render } from "./TableWithCustomHeader.vue?vue&type=template&id=1c62a172"
import script from "./TableWithCustomHeader.vue?vue&type=script&lang=js"
export * from "./TableWithCustomHeader.vue?vue&type=script&lang=js"
script.render = render

export default script